import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase";
import Cookies from "js-cookie";

Vue.use(VueRouter);
const ReferralComponent = {
  template: "<div>Referral</div>"
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/subscribe",
    name: "Subscribe",
    component: () => import("../views/Subscribe.vue")
  },
  {
    path: "/academy",
    name: "Academy",
    component: () => import("../views/Academy.vue")
  },
  {
    path: "/testimonials",
    name: "Testimonials",
    component: () => import("../views/Testimonials.vue")
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/legal",
    name: "Legal",
    component: () => import("../views/Legal.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/auth/Login.vue")
  },
  {
    path: "/admin-login",
    name: "AdminLogin",
    component: () => import("../views/auth/AdminLogin.vue")
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/auth/Signup.vue")
  },
  {
    path: "/referral/:id",
    name: "Referral",
    component: ReferralComponent
  },
  {
    path: "/user/welcome",
    name: "Welcome",
    component: () => import("../views/user/Welcome.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/user/payment",
    name: "Payment",
    component: () => import("../views/user/Payment.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/user",
    redirect: "/user/subscriptions",
    component: () => import("../views/user/UserLayout.vue"),
    children: [
      {
        path: "/user/subscriptions",
        name: "UserSubscription",
        component: () => import("../views/user/Subscriptions.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/user/tickets",
        name: "UserTickets",
        component: () => import("../views/user/Tickets.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/user/cards/new",
        name: "Payment",
        component: () => import("../views/user/Payment.vue"),
        meta: {
          requiresAuth: true,
          type: "addCard"
        }
      },
      {
        path: "/user/ticket/new",
        name: "NewTicket",
        component: () => import("../views/user/NewTicket.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/user/ticket/:id/reply",
        name: "ReplyTicket",
        component: () => import("../views/admin/ReplyTicket.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/user/cards",
        name: "Cards",
        component: () => import("../views/user/Cards.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/user/signals-history",
        name: "SignalHistory",
        component: () => import("../views/user/Signals.vue"),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    component: () => import("../views/admin/AdminLayout.vue"),
    children: [
      {
        path: "/admin/dashboard",
        name: "AdminDashboard",
        component: () => import("../views/admin/Dashboard.vue"),
        meta: {
          requiresAdminAuth: true
        }
      },
      {
        path: "/admin/subscribers",
        name: "Subscribers",
        component: () => import("../views/admin/Subscribers.vue"),
        meta: {
          requiresAdminAuth: true
        }
      },
      {
        path: "/admin/tickets",
        name: "AdminTickets",
        component: () => import("../views/admin/Tickets.vue"),
        meta: {
          requiresAdminAuth: true
        }
      },
      {
        path: "/admin/ticket/:id/reply",
        name: "AdminReplyTickets",
        component: () => import("../views/admin/ReplyTicket.vue"),
        props: true,
        meta: {
          requiresAdminAuth: true
        }
      },
      {
        path: "/admin/signals",
        name: "Signals",
        component: () => import("../views/admin/Signals.vue"),
        meta: {
          requiresAdminAuth: true
        }
      },
      {
        path: "/admin/signal/new",
        name: "NewSignal",
        component: () => import("../views/admin/NewSignal.vue"),
        meta: {
          requiresAdminAuth: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "is-active",
  routes
});

//router
router.beforeEach(async (to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdminAuth = to.matched.some(
    record => record.meta.requiresAdminAuth
  );
  if (to.path.includes("referral")) {
    Cookies.set("refferalId", to.params.id, { expires: 1 });
    if (currentUser) {
      next("/");
    } else {
      next("signup?type=referral");
    }
  }
  if (requiresAdminAuth) {
    if (currentUser) {
      let token = await currentUser.getIdTokenResult();
      token.claims.admin === true ? next() : next("login");
    } else {
      next("login");
    }
  } else if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("user/subscriptions");
  next();
});

export default router;
